/* eslint-disable no-unused-vars */
export enum EXPLORE_COST {
  FREE = "free",
  NOT_FREE = "not_free",
}
